import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { ExportTrackingService } from '../../../core';
import { ExportTask, ExportStatus } from '../../models/export-tracking.model';
import { IconModule } from '../icon/icon.module';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzCardComponent } from 'ng-zorro-antd/card';

@Component({
  selector: 'app-export-tracking',
  standalone: true,
  imports: [CommonModule, IconModule, NzButtonComponent, NzCardComponent],
  templateUrl: './export-tracking.component.html',
  styleUrls: ['./export-tracking.component.less']
})
export class ExportTrackingComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isVisible: boolean = false;
  @Output() close = new EventEmitter<void>();

  exports: ExportTask[] = [];
  readonly ExportStatus = ExportStatus;

  private destroy$ = new Subject<void>();

  constructor(private exportTrackingService: ExportTrackingService) {}

  ngOnInit(): void {
    this.exportTrackingService.exports
      .pipe(takeUntil(this.destroy$))
      .subscribe(exports => {
        this.exports = exports;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Cuando el componente se hace visible, cargar las exportaciones desde localStorage
    if (changes['isVisible'] && changes['isVisible'].currentValue === true) {
      this.exportTrackingService.loadExportsFromStorage();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onClose(): void {
    this.isVisible = false;
    this.close.emit();
  }

  openExportLink(task: ExportTask): void {
    if (task.downloadUrl) {
      window.open(task.downloadUrl, '_blank');
    }
  }

  retryExport(task: ExportTask): void {
    this.exportTrackingService.retryExport(task.id).subscribe({
      error: (error) => {
        console.error('Error al reintentar exportación:', error);
      }
    });
  }

  removeExport(task: ExportTask): void {
    this.exportTrackingService.removeExport(task.id);
  }

  clearCompleted(): void {
    this.exportTrackingService.clearCompletedExports();
  }
}

